import {Card, CardActions, IconButton, ListItem, ListItemText, Stack, styled} from '@mui/material';

const StyledCard = styled(Card)`
	padding: 16px;
`;

const StyledCardActions = styled(CardActions)`
	padding: 0;
`;

const StyledListItem = styled(ListItem)`
	.MuiListItemSecondaryAction-root {
		right: 0;
	}
`;

const StyledStackWrapper = styled(Stack)`
	flex: 1;
`;

const StyledStackContent = styled(Stack)`
	flex-direction: row;
	align-items: center;
	gap: 16px;
`;

const StyledListItemText = styled(ListItemText)`
	.MuiTypography-root {
		margin-left: -8px;
	}
`;

const StyledIconButton = styled(IconButton)`
	padding: 0;
`;

export {
	StyledListItem,
	StyledStackWrapper,
	StyledStackContent,
	StyledListItemText,
	StyledIconButton,
	StyledCard,
	StyledCardActions,
};
